// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  breadcrumb: null,
  paramsdata: null,
  loader: false,
  clickPass: false,
  filterData: null, // 👈 Added for filter persistence,
  dashboardReset: false,
};

// Redux Slice for AudioVideo
const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    resetState(state, { payload }) {
      // ⚠️ Don't reset filterData automatically — it should persist between navigations
      return {
        ...initialState,
        filterData: state.filterData, // 👈 keep filters        
      };
    },
    setBreadcrumb(state, { payload }) {
      return {
        ...state,
        breadcrumb: payload,
      };
    },
    setLoader(state, { payload }) {
      return {
        ...state,
        loader: payload,
      };
    },
    setParamsData(state, { payload }) {
      return {
        ...state,
        paramsdata: {
          ...state.paramsdata,
          ...payload,
        },
      };
    },
    setClickPass(state, { payload }) {
      return {
        ...state,
        clickPass: payload,
      };
    },
    // 👇 New reducers for filter persistence
    setFilterData(state, { payload }) {
      return {
        ...state,
        filterData: payload,
      };
    },
    setDashboardReset(state, { payload }) {
      return {
        ...state,
        dashboardReset: payload,
      };
    },
    clearFilterData(state) {
      return {
        ...state,
        filterData: null,
      };
    },
  },
});

export const commonSliceActions = commonSlice.actions;

export default commonSlice;
